export const DOCUMENT_REQUEST_CATEGORY = {
  PROOF_OF_RESIDENCY: 'PROOF_OF_RESIDENCY',
  PROOF_OF_CITIZENSHIP: 'PROOF_OF_CITIZENSHIP',
  NON_APPOINTED_CARRIER_INFO: 'NON_APPOINTED_CARRIER_INFO',
  INDIVIDUAL_PLAN_NOT_SURECO_MANAGED: 'INDIVIDUAL_PLAN_NOT_SURECO_MANAGED',
  PROOF_OF_ADULT_CHILD_DISABILITY: 'PROOF_OF_ADULT_CHILD_DISABILITY',
  SYSTEM_GENERATED: 'SYSTEM_GENERATED',
  MEDICARE_AGE_IN: 'MEDICARE_AGE_IN',
  QLE_EVIDENCE: 'QLE_EVIDENCE',
  PROOF_OF_MEDICARE: 'PROOF_OF_MEDICARE',
}

export const DOCUMENT_CATEGORY_LABELS = {
  [DOCUMENT_REQUEST_CATEGORY.PROOF_OF_RESIDENCY]: 'Proof of Residence',
  [DOCUMENT_REQUEST_CATEGORY.PROOF_OF_CITIZENSHIP]: 'Proof of Citizenship',
  [DOCUMENT_REQUEST_CATEGORY.NON_APPOINTED_CARRIER_INFO]: 'Non-appointed carrier information',
  [DOCUMENT_REQUEST_CATEGORY.INDIVIDUAL_PLAN_NOT_SURECO_MANAGED]:
    'Individual plan (not SureCo-managed)',
  [DOCUMENT_REQUEST_CATEGORY.PROOF_OF_ADULT_CHILD_DISABILITY]: 'Adult child disability',
  [DOCUMENT_REQUEST_CATEGORY.QLE_EVIDENCE]: 'QLE Evidence',
  [DOCUMENT_REQUEST_CATEGORY.MEDICARE_AGE_IN]: 'Medicare age-in',
  [DOCUMENT_REQUEST_CATEGORY.PROOF_OF_MEDICARE]: 'Proof of Medicare',
}
